import styled from 'styled-components'
import { Select as AntSelect, Segmented as AntSegmented } from 'antd'

export const PageWrapper = styled.div`
  padding: 24px;
  background: #fff;
  min-height: calc(100vh - 64px);
`

export const BreadcrumbText = styled.span`
  font-size: 12px;
  color: #667085;
  cursor: pointer;
  &:hover {
    color: #3249d7;
  }
`

export const BreadcrumbSeparator = styled.span`
  font-size: 12px;
  color: #667085;
  margin: 0 4px;
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const PageTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #1d2939;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
`

export const BackArrow = styled.span`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #667085;
  &:hover {
    color: #3249d7;
  }
`

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;
`

export const ShowingText = styled.span`
  font-size: 13px;
  color: #667085;
  white-space: nowrap;
`

export const TableWrapper = styled.div`
  .ant-table-thead > tr > th {
    background: #f9fafb;
    font-weight: 600;
    font-size: 13px;
    color: #667085;
    text-transform: uppercase;
  }
  .ant-table-tbody > tr > td {
    font-size: 14px;
  }
`

export const CollegeName = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const CollegeLogo = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f2f4f7;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const CollegeText = styled.span`
  font-weight: 500;
  color: #1d2939;
`

export const LocationText = styled.div`
  font-size: 13px;
  color: #667085;
`

export const TierBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  background: ${props => {
    switch (props.tier) {
      case 1: return '#EBF5FF'
      case 2: return '#F0FDF4'
      case 3: return '#FFF7ED'
      case 4: return '#FEF3F2'
      default: return '#F2F4F7'
    }
  }};
  color: ${props => {
    switch (props.tier) {
      case 1: return '#1570EF'
      case 2: return '#067647'
      case 3: return '#B93815'
      case 4: return '#B42318'
      default: return '#667085'
    }
  }};
  border: 1px solid ${props => {
    switch (props.tier) {
      case 1: return '#B2DDFF'
      case 2: return '#ABEFC6'
      case 3: return '#F9DBAF'
      case 4: return '#FECDCA'
      default: return '#E4E7EC'
    }
  }};
`

export const LinkCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const LinkText = styled.a`
  color: #3249d7;
  font-size: 13px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  &:hover {
    text-decoration: underline;
  }
`

export const CopyIcon = styled.span`
  cursor: pointer;
  color: #667085;
  display: flex;
  align-items: center;
  &:hover {
    color: #3249d7;
  }
`

export const UpdatePocButton = styled.span`
  color: #3249d7;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
`

export const EmailSentBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #067647;
  font-size: 13px;
  font-weight: 500;
`

export const PilBadge = styled.span`
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 500;
  background: #eff8ff;
  color: #175cd3;
  border: 1px solid #b2ddff;
`

export const DrawerContent = styled.div`
  padding: 16px 0;
`

export const PocItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  margin-bottom: 12px;
`

export const PocLabel = styled.span`
  font-size: 12px;
  color: #667085;
`

export const PocValue = styled.span`
  font-size: 14px;
  color: #1d2939;
  font-weight: 500;
`

export const ConfirmContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px;
  gap: 16px;
`

export const ConfirmText = styled.p`
  font-size: 16px;
  color: #1d2939;
  margin: 0;
`

export const EmailFormWrapper = styled.div`
  padding: 0;
`

export const EmailLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #4d566e;
  display: block;
  margin-bottom: 4px;
`

/* ---------- Filter bar ---------- */

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 14px 16px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  margin-bottom: 16px;
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: ${props => props.width || '150px'};
`

export const FilterLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #667085;
`

export const FilterSelect = styled(AntSelect)`
  width: 100%;
  .ant-select-selector {
    border-radius: 8px !important;
    border-color: #d0d5dd !important;
    min-height: 38px !important;
    display: flex;
    align-items: center;
    transition: border-color 150ms ease;
  }
  &:hover .ant-select-selector {
    border-color: #3249d7 !important;
  }
  &.ant-select-focused .ant-select-selector {
    border-color: #3249d7 !important;
    box-shadow: 0 0 0 3px rgba(50, 73, 215, 0.12) !important;
  }
`

export const FilterSegmented = styled(AntSegmented)`
  border-radius: 8px;
  background: #f2f4f7;
  padding: 3px;
  font-family: inherit;
  .ant-segmented-item {
    transition: color 150ms ease;
    color: #667085;
    border-radius: 6px;
  }
  .ant-segmented-item:hover:not(.ant-segmented-item-selected) {
    color: #3249d7;
  }
  .ant-segmented-item-label {
    min-height: 30px;
    line-height: 30px;
    padding: 0 12px;
    font-size: 13px;
  }
  .ant-segmented-item-selected {
    background: #ffffff;
    color: #3249d7;
    font-weight: 600;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1);
  }
  .ant-segmented-thumb {
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1);
  }
`

export const ClearAllButton = styled.button`
  margin-left: auto;
  align-self: center;
  background: none;
  border: none;
  padding: 8px 4px;
  color: #3249d7;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: color 150ms ease;
  &:hover {
    text-decoration: underline;
  }
  &:disabled {
    color: #98a2b3;
    cursor: not-allowed;
    text-decoration: none;
  }
`

export const SelectAllBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 14px;
  background: #f9fafb;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  font-size: 13px;
  color: #344054;
  margin-bottom: 12px;
  flex-wrap: wrap;
  strong { font-weight: 600; }
`

export const SelectAllLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: #3249d7;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  &:hover { text-decoration: underline; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
`
